export function encode(value) {
    return btoa(value);
}
export function decode(value) {
    return atob(value);
}
